import React from 'react'
import auth from '../api/auth'

const KEY = 'access-token'

export default (url) => {
  const token = window.localStorage.getItem(KEY)
  const [isAuthenticated, setIsAuthenticated] = React.useState(!!token)
  const [userInfo, setUserInfo] = React.useState({})
  console.log(url)
  const signin = (email, password) => auth({ username: email, password }, url)
    .then((t) => {
      window.localStorage.setItem(KEY, t)
      setIsAuthenticated(true)
      setUserInfo(t)
      return new Promise((resolve) => resolve(t))
    })
    .catch(() => new Promise((resolve) => resolve(false)))

  const signout = () => new Promise((resolve) => {
    window.localStorage.removeItem(KEY)
    setIsAuthenticated(false)
    setUserInfo({})
    resolve(false)
  })

  // Return the user object and auth methods
  return {
    userInfo,
    user: isAuthenticated,
    signin,
    signout,
  }
}
